export const SAT_TESTING_TYPES = ['sat'];
const isSat = (type: string) => SAT_TESTING_TYPES.includes(type);

interface StandardItem {
  type: string;
  total: number;
  reading_and_writing: number;
  math: number;
}

export default class SatConverter {
  static is = isSat;
  static isValid = (item: StandardItem) => {
    return item.total > 0 || item.reading_and_writing > 0 || item.math > 0;
  };

  static toArray(resume: Record<string, any>) {
    return SAT_TESTING_TYPES.map((type) => {
      return {
        type,
        ...resume['sat_i_test_score'],
      };
    }).filter(Boolean);
  }

  static toValidArray(resume: Record<string, any>) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }

  static toObject(items: StandardItem[]) {
    const resume = {};
    items.forEach((item) => {
      if (this.is(item.type)) {
        resume['sat_i_test_score'] = item;
      }
    });
    return resume;
  }

  static toObjectV3(obj: Record<string, any>) {
    const resume = {};
    resume['sat_i_test_score'] = {
      type: 'sat',
      ...obj,
    };
    return resume;
  }

  static defaults() {
    return {
      sat_i_test_score: {
        total: 0,
        reading_and_writing: 0,
        math: 0,
      },
    };
  }
}
